export const styles = {
  current: {
    color: '#ef3124'
  },
  ratingItem: {
    display: 'flex',
    'align-items': 'center',
  },
}